import { MoveLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { ROUTES } from '@/common/constants/routes'

export function ErrorMessage() {
  const { t } = useTranslation('login')

  return (
    <div className="flex flex-col gap-6">
      <div className="bg-danger-50 border border-danger-200 rounded-lg p-6 text-center">
        <h3 className="text-danger-900 font-medium mb-2">
          {t('activate_user.error.title')}
        </h3>
        <p className="text-danger-700 text-sm">
          {t('activate_user.error.message')}
        </p>
      </div>

      <Link
        to={ROUTES.LOGIN.SIGN_IN}
        className="text-brand-400 text-sm flex gap-2 items-center justify-center mt-4"
      >
        <MoveLeft className="text-brand-600 size-4 stroke-2" />
        {t('activate_user.go_to_login')}
      </Link>
    </div>
  )
}
